import { RegisterSalesAgreement } from '@features/TimberBuyer/SalesAgreements/Register/Register'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

export const Route = createFileRoute('/timberbuyer/$timberBuyerId/sales-agreements/register')({
  component: RegisterSalesAgreement,
  staticData: { breadcrumb: t('timberbuyer-salesagreements-register.breadcrumb') },
})
